<script lang="ts" setup>
import { TicketState, getTicketStateLabelByValue } from '~/constants/ticketStates'
import { useWindowSize } from '@vueuse/core'
import Header from '~/components/layouts/Header.vue'
import Footer from '~/components/layouts/Footer.vue'
import BottomBar from '~/components/custom-ui/BottomBar.vue'

definePageMeta({
	name: 'help_ticket'
})

const { width, height } = useWindowSize()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const showDetail = ref(false);
const openChatModal = ref(false)
const loading = ref(false)
const config = useRuntimeConfig()
/* const {data: chatList, refresh } = await useAsyncData('chat_list', () => getChats())

async function getChats(){
	loading.value = true
	await nextTick()
	let endpoint = endpoints.chat.client_chats
	if(userStore.user?.user_role === RoleEnum.MASTER){
		endpoint = endpoints.chat.master_chats
	}
	return await fetchAuth<ResponseType[]>(endpoint, {
		method: 'GET',
	}).then(({data, meta}) => {
		if(!data) return []
		return data.filter((chat) => !!chat.task).map((chat) => {
			chat.timestamp = chat.messages[0] ? new Date(chat.messages[0].createdAt).getTime() : 0
			return chat
		})
	}).catch((e) => {
		console.error(e)
		return []
	}).finally(() => {
		loading.value = false
	})
} */

/* const { data: ticketsList, status: loadedStatus } = await useAsyncData<any[]>('help_tickets',
	() => getTickets() as Promise<any[]>
);

async function getTickets() {
	if (!userStore.user?.documentId) {
		return []
	}

	return await fetchData('/help/tickets', {
		baseURL: '/local-api',
		method: 'GET',
		query: {
			documentId: userStore.user?.documentId,
		}
	}).then(({ data }) => {
		return data
	}).catch((error) => {
		console.error(error)
	})
}

const sortedTickets = computed(() => {
	if (!ticketsList.value) return []
	return ticketsList.value.sort((a: any, b: any) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime())
}) */

const isMobile = computed(() => {
	return width.value <= 768
})

const chatContainer = ref<HTMLElement | null>(null)

const ticketData = useState<any>('ticketData')

const ticketStateLabel = computed(() => {
	if (!ticketData.value) return ''
	return getTicketStateLabelByValue(ticketData.value.state_id)
})

const ticketStateClasses = computed(() => {
	if (!ticketData.value) return ''
	return {
		'text-accent': [TicketState.new, TicketState.pending_reminder].includes(ticketData.value.state_id),
		'text-primary-500': [TicketState.open, TicketState.merged].includes(ticketData.value.state_id),
		'text-gray-800': [TicketState.pending_close, TicketState.closed].includes(ticketData.value.state_id),
	}
})

</script>

<template>
	<div class="min-h-screen flex flex-col justify-between">
		<div class="main_row">
			<Header />
			<div class="flex flex-col mx-auto">
				<div v-if="ticketData" class="container max-w-[425px] mx-auto py-10 text-center">
					<p class="text-gray-500 text-sm mb-2">{{ $t('Ticket') }} #{{ ticketData?.id }}</p>
					<h1 v-if="ticketData?.title" class="text-5xl font-bold">{{ ticketData.title }}</h1>
					<p v-if="ticketData?.issue" class="text-sm mt-2">{{ ticketData.issue }}</p>

					<div class="flex gap-6 items-center mt-4 justify-center">
						<div v-if="ticketStateLabel" class="">
							<p class="text-xs text-gray-500">{{ $t('Status') }}</p>
							<p class="text-sm font-medium" :class="ticketStateClasses">{{ ticketStateLabel }}</p>
						</div>
						<div v-if="ticketData.created_at" class="">
							<p class="text-xs text-gray-500">{{ $t('Created at') }}</p>
							<p class="text-sm ">{{ formatDate(ticketData.created_at) }}</p>
						</div>
					</div>

				</div>

					<div class="ys-block-info h-full bg-gray-100">
						<!-- <div class="mobile_header md:hidden grid grid-cols-6 items-center mb-6">
							<div class="col-span-1">
								<UiButton @click.prevent="router.back()" variant="ghost" class="p-0">
									<Icon name="ri:arrow-left-line" size="24px" />
								</UiButton>
							</div>
							<div class="col-span-4">
								<p class="text-center font-medium uppercase text-[13px] tracking-widest leading-none">{{
									$t('Chats') }}</p>
								<p class="text-center text-[10px] text-gray-400">{{ $t('Discussions') }}</p>
							</div>
							<div class="col-span-1">
							</div>
						</div> -->
						<div class="container max-w-[600px] mx-auto">
							<NuxtPage />
						</div>
							
					</div>
			</div>
		</div>
		<Footer />
		<BottomBar />
	</div>
</template>

<style scoped lang="scss">
.wrapper {
	min-height: 530px;
	overflow: hidden;
}

.ys-block-info {
	.ys-block-inf-img {
		// width: 1040px;
		height: 325px;
		top: 228px;
		left: 352px;
		padding: 30px 0;
		gap: 16px;
		border-radius: 20px;
		background: rgba(247, 254, 248, 1);
	}
}

.ys-profile-layout {
	width: 1072px;
	height: 88px;
	top: 110px;
	left: 320px;
	padding: 20px 0 20px 32px;
	gap: 12px;
}

.ys-profile-button {
	width: 159px;
	height: 40px;
	padding: 10px;
	gap: 4px;
	border-radius: 10px;
}

.ys-home-text {
	font-family: Involve, sans-serif;
	color: rgba(0, 0, 0, 1);
	font-size: 34px;
	line-height: 45px;

	@media(max-width: 768px) {
		font-size: 21px;
	}
}
</style>